export const headerNavItems = [
  { label: 'О форуме', href: '#about' },
  { label: 'Партнёры', href: '#partners' },
  { label: 'Программа', href: '#program' },
  { label: 'Участвовать', href: '#participate' },
  { label: 'Вопросы', href: '#questions' }
];
